import React, { useMemo, useState, useEffect } from "react"
import { useTable } from "react-table"
import { Table } from "reactstrap"
import { Checkbox } from "@mui/material"

const DropshipSelectionTable = ({
  columns,
  data,
  order_id,
  selectedDropshipProducts,
  checkedArrayDropshipSelection, setCheckedArrayDropshipSelection,
  dropshipData, setDropshipData,
  dropshippedData
}) => {
  const columnData = useMemo(() => {
    const hiddenKeys = ["status", "item.estimate"]
    return columns.filter(col => !hiddenKeys.includes(col.accessor))
  }, [columns])

  const rowData = useMemo(() => data, [data])

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns: columnData,
        data: rowData,
      },
    )
  
  useEffect(() => {
    const initial = rows.map(row => {
        return Array.from({ length: row.original.quantity }, (_, qIndex) => {
            const checkboxKey = `${order_id}.${row.original.product_id}.${qIndex + 1}`;
            let state = row.original.item?.sku?.startsWith('Z') || false;
            const isMatched = dropshippedData.some(dropship => dropship.line_item_id === checkboxKey);
            if (isMatched) {
              state = false;
            }
            if (state === true) {
              selectedDropshipProducts(
                checkboxKey,
                row.original.product_id,
                state
              );
            }
            return state
          }
        )
      }
    );
    setCheckedArrayDropshipSelection(initial);
  }, [rows]);

  const dropshipDataRender = [...dropshipData];

  dropshippedData.forEach(dropship => {
    dropshipDataRender.push({ line_id: dropship.line_item_id, added: true });
  });

  return (
        <>
          <div
            className="table-responsive react-table mt-1"
          >
            <Table {...getTableProps()}>
              
              {(() => {
                // Get all line_ids expected from all rows
                const allLineIds = rows.flatMap(row =>
                  Array.from({ length: row.original.quantity }).map((_, qIndex) =>
                    `${order_id}.${row.original.product_id}.${qIndex + 1}`
                  )
                );

                // Check if all line_ids are found in dropshipDataRender
                const allRowsApplied = allLineIds.every(
                  lineId => dropshipDataRender.some(item => item.line_id === lineId)
                );

                if (allRowsApplied) return null;

                return (
                  <thead>
                    {headerGroups.map((headerGroup, i) => (
                      <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                        <th></th>
                        {headerGroup.headers.map((column, i) => (
                          <th key={i} {...column.getHeaderProps()}>
                            <div className="mb-2">
                              {column.render("Header")?.toUpperCase()}
                            </div>
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                );
              })()}

              <tbody {...getTableBodyProps()}>
                {rows && rows?.length > 0 ?
                  rows.map((row, i) => {
                    prepareRow(row)
                    return (
                      <React.Fragment key={i}>
                        {(() => {
                          const allLineIds = Array.from({ length: row.original.quantity }).map((_, qIndex) =>
                            `${order_id}.${row.original.product_id}.${qIndex + 1}`
                          );

                          const allSubRowsHidden = allLineIds.every(lineId =>
                            dropshipDataRender.some(item => item.line_id === lineId)
                          );

                          if (allSubRowsHidden) return null;

                          return (
                            <tr key={`${i}_dm`} {...row.getRowProps()}>
                              <td></td>
                              {row.cells.map((cell, i) => (
                                <td
                                  style={{ fontSize: 12 }}
                                  key={i}
                                  {...cell.getCellProps()}
                                >
                                  {cell.render("Cell")}
                                </td>
                              ))}
                            </tr>
                          );
                        })()}

                        {Array.from({ length: row.original.quantity }).map((_, qIndex) => {
                          const lineId = `${order_id}.${row.original.product_id}.${qIndex + 1}`;
                          const shouldShow = !dropshipDataRender.some(item => item.line_id === lineId);

                          if (!shouldShow) return null;

                          return (
                            <tr key={`${i}_sub_${qIndex}`}>
                              <td colSpan={row.cells.length}>
                                <Checkbox
                                  style={{ marginLeft: 20 }}
                                  checked={checkedArrayDropshipSelection[i]?.[qIndex] || false}
                                  onChange={(e) => {
                                    const state = e.target.checked;
                                    const newChecked = [...checkedArrayDropshipSelection];
                                    newChecked[i] = [...(newChecked[i] || [])];
                                    newChecked[i][qIndex] = state;
                                    setCheckedArrayDropshipSelection(newChecked);

                                    const checkboxKey = `${order_id}.${row.original.product_id}.${qIndex + 1}`;
                                    selectedDropshipProducts(
                                      checkboxKey,
                                      row.original.product_id,
                                      state
                                    );
                                  }}
                                />
                                {lineId}
                              </td>
                            </tr>
                          );
                        })}
                        
                      </React.Fragment>
                    )
                  })
                  : <p><strong>No Data Found</strong></p>
                }
              </tbody>
            </Table>
          </div>
        </>
  )
}

export default DropshipSelectionTable
